var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 35110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 310",
    d: "M10.7672 21.8538H3.875C2.21815 21.8538 0.875 20.5106 0.875 18.8538V8.46094C0.875 6.80408 2.21815 5.46094 3.875 5.46094H4.8319",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 311",
    d: "M10.1078 21.8538H17C18.6569 21.8538 20 20.5106 20 18.8538V8.46094C20 6.80408 18.6569 5.46094 17 5.46094H16.0431",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 35109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4314 15.5V1L7.69922 3.73214",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4297 1L13.1618 3.73214",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/ios_icon.a64b8de69b4a3bd06288d2c9268daa3b.svg";
export { ForwardRef as ReactComponent };